import { WheelData } from 'components/wheelOfFortune/WheelOfFortune/types';

import { TaskData } from '../components/TaskItem';
import { ReferralEventData } from '../types/';

import eventBg from 'assets/single-event/event_bg.png';

const pastTimestamp = Math.floor(new Date('2025-09-30T00:00:00Z').getTime() / 1000);
const futureTimestamp0 = Math.floor(new Date('2025-11-06T00:00:00Z').getTime() / 1000);
const futureTimestamp1 = Math.floor(new Date('2026-11-30T23:59:59Z').getTime() / 1000);
const futureTimestamp2 = Math.floor(new Date('2026-12-31T23:59:59Z').getTime() / 1000);

export const MOCK_WHEEL_DATA: WheelData[] = [
  { option: '0 RMV', optionSize: 1 },
  { option: '0.01 RMV', optionSize: 1 },
  { option: '0.1 RMV', optionSize: 1 },
  { option: '0.5 RMV', optionSize: 1 },
  { option: '1 RMV', optionSize: 1 },
  { option: '2 RMV', optionSize: 1 },
  { option: '5 RMV', optionSize: 1 },
  { option: '20 RMV', optionSize: 1 },
  { option: '100 RMV', optionSize: 1 },
  { option: '500 RMV', optionSize: 1 },
  { option: '1000 RMV', optionSize: 1 },
  { option: '10000 RMV', optionSize: 1 },
];

export const MOCK_TASKS: TaskData[] = [
  { id: 1, name: 'Stake 100K', description: 'Stake at least 100K RMV tokens to earn rewards.', currentValue: 50000, targetValue: 100000, status: 'claimed', isVip: true },
  { id: 2, name: 'Refer 10 Friends', description: 'Invite 10 friends who complete registration.', currentValue: 7, targetValue: 10, status: 'in_distribution', endsIn: '2D 4H 23S', isCompleted: true },
  { id: 3, name: 'Trade 50K Volume', description: 'Reach 50K trading volume in eligible pairs.', currentValue: 50000, targetValue: 50000, status: 'expired' },
  { id: 4, name: 'Hold 1M RMV', description: 'Maintain a balance of 1M RMV tokens.', currentValue: 1234567, targetValue: 1000000, status: 'distributed', isCompleted: true },
  { id: 5, name: 'Daily Login Streak', description: 'Log in for 7 consecutive days.', currentValue: 0, targetValue: 7, status: 'upcoming' },
  { id: 6, name: 'Complete KYC', description: 'Verify your identity to unlock rewards.', currentValue: 0, targetValue: 1, status: 'available', endsIn: '5D 12H 00S' },
  { id: 7, name: 'Buy 5 wNFTs', description: 'Purchase at least 5 fractional NFTs.', currentValue: 3, targetValue: 5, status: 'in_progress', endsIn: '1D 8H 45S' },
  { id: 8, name: 'Earn 500 RMV', description: 'Accumulate 500 RMV from referral rewards.', currentValue: 500, targetValue: 500, status: 'claimable', endsIn: '3D 0H 10S' },
  { id: 9, name: 'Join Discord', description: 'Connect your Discord account and join the community server.', currentValue: 1, targetValue: 1, status: 'claimed' },
  { id: 10, name: 'Follow on X', description: 'Follow RealityMeta on X (Twitter) and like the pinned post.', currentValue: 0, targetValue: 1, status: 'available', endsIn: '10D 0H 0S' },
];

export const MOCK_TASK_BASED_EVENT_DATA: ReferralEventData = {
  name: 'Task-Based Challenge',
  tagline: 'COMPLETE __TASKS__ - SPIN THE __WHEEL__ - WIN __REWARDS__',
  imageUrl: eventBg,
  bannerUrl: 'https://assets.r5y.io/lgo-live/event/banners/vip_ref.png',
  iconUrl: 'https://assets.r5y.io/lgo-live/event/images/vip_ref.png',
  tiers: [
    { label: 'Bronze', requiredRewards: 5 },
    { label: 'Silver', requiredRewards: 15 },
    { label: 'Gold', requiredRewards: 30 },
    { label: 'Platinum', requiredRewards: 50 },
    { label: 'Diamond', requiredRewards: 100 },
  ],
  currentRewards: 12,
  nextRewardAt: 15,
  nextMilestoneName: 'Silver Tier',
  badges: [{ text: '5 Tasks Done' }],
  tableData: {
    rows: [
      {
        rank: '1',
        walletAddress: '0x1234...5678',
        wnftPurchased: '10',
        prize: '1000 RMV + 1x wNFT',
        isActive: true,
      },
      { rank: '2', walletAddress: '0x8765...4321', wnftPurchased: '7', prize: '500 RMV', isActive: false },
      { rank: '3', walletAddress: '0xabcd...efgh', wnftPurchased: '5', prize: '250 RMV', isActive: false },
      { rank: '4', walletAddress: '0x9876...1234', wnftPurchased: '3', prize: '100 RMV', isActive: false },
    ],
    pagination: {
      currentPage: 1,
      totalPages: 3,
      hasNextPage: true,
      hasPreviousPage: false,
    },
  },
  chartData: [
    { label: '2025-11-10', value1: 5, value2: 5 },
    { label: '2025-11-11', value1: 8, value2: 13 },
    { label: '2025-11-12', value1: 12, value2: 25 },
    { label: '2025-11-13', value1: 6, value2: 31 },
    { label: '2025-11-14', value1: 10, value2: 41 },
    { label: '2025-11-15', value1: 15, value2: 56 },
    { label: '2025-11-16', value1: 9, value2: 65 },
    { label: '2025-11-17', value1: 20, value2: 85 },
  ],
  analyticsEvents: [
    { id: 1, name: 'Weekly Sprint', imageUrl: eventBg, isVip: false, isUpcoming: false, eventType: 'referral' },
    { id: 2, name: 'Referral Rush', imageUrl: eventBg, isVip: true, isUpcoming: true, eventType: 'referral' },
    { id: 3, name: 'Trading Challenge', imageUrl: eventBg, isVip: false, isUpcoming: true, eventType: 'trading' },
  ],
  participationCriteria: [
    {
      title: 'Event Timeline',
      description: '2025/09/30 00:00 - 2026/12/31 23:59 (UTC)',
    },
    {
      title: 'Eligibility',
      description:
        'Complete tasks to earn spins on the Wheel of Fortune. Each completed task grants one spin. Higher-value tasks may grant bonus spins.',
    },
    {
      title: 'Rewards',
      description:
        'Spin the wheel to win RMV tokens or wNFTs. Prizes range from 50 RMV to 1000 RMV and exclusive wNFTs.',
    },
  ],
  circularProgressOverlay: {
    title: 'Silver Tier',
    nextRewardName: 'Silver Badge',
  },
  quickSummaryStats: {
    ctaLabel: 'Connect wallet',
    items: [
      { title: 'Tasks Completed', value: '12' },
      { title: 'Spins Available', value: '3' },
      { title: 'Total RMV Won', value: '450' },
      { title: 'wNFTs Won', value: '1' },
      { title: 'Current Streak', value: '5' },
    ],
  },
  endAt: futureTimestamp2,
  stages: [
    { id: 1, name: 'REGISTRATION STARTS', timestamp: pastTimestamp },
    { id: 2, name: 'EVENT STARTS', timestamp: futureTimestamp0 },
    { id: 3, name: 'REGISTRATION ENDS', timestamp: futureTimestamp1 },
    { id: 4, name: 'EVENT ENDS', timestamp: futureTimestamp2 },
    { id: 5, name: 'REWARDS DISTRIBUTION', timestamp: futureTimestamp2, description: 'After event ends' },
  ],
  status: 1,
  isParticipating: false,
  eventType: 'referral',
};
